import React from "react";
import { Dialog } from "@mui/material";
import Paper from "../CustomPaper/Paper";

const CustomDialog = ({ open, onClose, children, className, ...props }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      sx={{ minWidth: "450px" }}
      classes={{ paper: className }}
      PaperComponent={Paper}
      {...props}
    >
      {open && children}
    </Dialog>
  );
};

export default CustomDialog;
